export default {
  items: [
    {
      name: 'home',
      url: '/',
      icon: 'fa fa-home',
      show: true,
      attributes: {
        exact: true
      },
    },
    {
      name: 'dashboard',
      url: '/admin/dashboard',
      icon: 'icon-speedometer',
      show: true,
      attributes: {
        exact: true
      },
    },
    {
      name: 'manager',
      icon: 'cui-briefcase',
      code: 'base_users',
      url: '/admin/users',
      attributes: {
        exact: true
      },
      children: [
        {
          name: 'users',
          url: '/admin/users',
          icon: 'cui-user',
          attributes: {
            exact: true
          },
        },
        {
          name: 'roles',
          url: '/admin/users/roles',
          icon: 'cui-graph',
          attributes: {
            exact: true
          },
        }
      ],
      permission: "admin",
    },
    {
      name: 'integrations.title',
      icon: 'cui-cog',
      url: '/admin/integrations',
      attributes: {
        exact: true,
      },
      permission: "admin",
      onlyDev: true
    },
    // {
    //   name: 'satellites.title',
    //   icon: 'fa fa-space-shuttle',
    //   url: '/admin/satellites',
    //   attributes: {
    //     exact: true,
    //   },
    //   permission: "admin",
    //   onlyDev: true
    // },
    {
      name: 'templates',
      icon: 'fa fa-archive',
      url: '/admin/templates',
      attributes: {
        exact: true,
      },
      permission: "admin"
    },
    {
      name: 'developer',
      icon: 'bi bi-braces',
      url: '/admin/developer',
      attributes: {
        exact: true,
      },
      onlyDev: true
    }
  ]
}
